{
    "name": "SiteContext",
    "schemas": "@wix/dm-fragment-schemas/siteContext",
    "defaultConfigurations": {
        "singletonInstance": "SiteContextSingleton"
    }
}
